import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { HospitalizationService } from 'src/app/api/services';
import { checkExistingPrehospi, checkExistingPrehospiFailure, checkExistingPrehospiSuccess, createPrehospi, createPrehospiFailure, createPrehospiSuccess, getMedicalForm, getMedicalFormFailure, getMedicalFormSuccess, sendMedicalForm, sendMedicalFormFailure, sendMedicalFormSuccess, getPrintLight, getPrintLightFailure, getPrintLightSuccess } from './hospi.actions';

@Injectable()
export class HospiEffects {

	constructor(private actions$: Actions, private hospitalizationService: HospitalizationService) { }

	public checkExistingPrehospi$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(checkExistingPrehospi),
			switchMap(({ siteId, insurerId, contractId }) =>
				this.hospitalizationService.hospitalizationCheckExistingPreHospi({ siteId: siteId }).pipe(
					map((hospi) => {
						if (hospi == null)
							throw new Error();

						return checkExistingPrehospiSuccess({ data: hospi });
					}),
					catchError((err) => of(checkExistingPrehospiFailure({ error: err })))
				)
			)
		);
	});

	public createPrehospi$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(createPrehospi),
			switchMap(({ data }) =>
				this.hospitalizationService.hospitalizationCreateKioskPrehospi({body:data}).pipe(
					map((hospi) => {
						if (hospi == null)
							throw new Error();

						return createPrehospiSuccess({ data: hospi });
					}),
					catchError((err) => of(createPrehospiFailure({ error: err.message })))
				)
			)
		);
	});


	public getMedicalForm$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(getMedicalForm),
			switchMap(({ languageCode, hospitalizationId }) =>
				this.hospitalizationService.hospitalizationGetMedicalFormPdf$Pdf({
					languageCode: languageCode, hospitalizationId: hospitalizationId
				}).pipe(
					map((data) => getMedicalFormSuccess({ data: data })),
					catchError((err) => of(getMedicalFormFailure({ error: err })))
				)
			)
		);
	});

	public sendMedicalForm$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(sendMedicalForm),
			switchMap(({ languageCode, hospitalizationId, medicalForm, recipient }) =>
				this.hospitalizationService.hospitalizationSendMedicalForm({ body: {
					language: languageCode,
					hospitalizationId: hospitalizationId, medicalForm: medicalForm, recipient: recipient
				}}).pipe(
					map((data) =>sendMedicalFormSuccess({ data: data })),
					catchError((err) => of(sendMedicalFormFailure({ error: err })))
				)
			)
		);
	});

	public getPrintLight$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(getPrintLight),
			switchMap(({languageCode, hospitalizationId, messageId }) =>
				this.hospitalizationService.hospitalizationGetPrintLightPdf$Pdf({
					languageCode: languageCode,
					hospitalizationId: hospitalizationId,
					messageId: messageId}).pipe(
					map((data) => getPrintLightSuccess({ data: data })),						
					catchError((err) => of(getPrintLightFailure({ error: err })))
				)
			)
		);
	});
}
